import { tv } from 'tailwind-variants';

export const expandableListVariants = tv({
  slots: {
    header:
      'gap-xs inline-flex items-center whitespace-nowrap justify-between w-full cursor-pointer',
    headerLabel: 'flex-1',
    arrow: 'pr-sm',
  },
  base: 'gap-xs flex-col w-full select-none',
});
